import {SET_ME} from "../types"
import {MeType, SetMeAction} from "../interface"

export default function setMe(me: MeType): SetMeAction {
  return {
    type: SET_ME,
    me: me,
  }
}
